module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stockData",
    attrs: {
      "id": "depositData"
    }
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showVipList = false;
      }
    }
  }, [(_vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "change-type"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'STOCK'
      }
    }
  }, [_vm._v("仓库")]), _vm._v(" "), _c('span', {
    class: _vm.nowType == 'STOCK' ? 'type-wrap' : 'type-wrap to-right',
    on: {
      "click": function($event) {
        _vm.nowType == 'STOCK' ? _vm.nowType = 'BAR' : _vm.nowType = 'STOCK'
      }
    }
  }, [_c('i', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'BAR'
      }
    }
  }, [_vm._v("吧台")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchConfirm(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.nowType == 'STOCK') ? _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.depositList.length > _vm.pageSize
    }
  }, _vm._l((_vm.depositList), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (ind + 1) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      },
      attrs: {
        "title": item.skuName
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.skuName) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.lastQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.purchaseInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.allocationInQty) : ""))]), _vm._v(" "), _c('td', {
      class: item.skuName ? 'border' : '',
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.barInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.innerOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkoutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.refundOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.allocationOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.nowQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.value) : ""))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'BAR') ? _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.depositListForBar.length > _vm.pageSize
    }
  }, _vm._l((_vm.depositListForBar), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (ind + 1) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      },
      attrs: {
        "title": item.skuName
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.skuName) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.lastQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.innerInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.stockInnerInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkInQty) : ""))]), _vm._v(" "), _c('td', {
      class: item.skuName ? 'border' : '',
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.refundInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.salesOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.innerOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.barOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkoutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.nowQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.value) : ""))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [(_vm.nowType == 'BAR') ? _c('span', [_vm._v("总库存剩余数：" + _vm._s(_vm.totalInfoForBar.totalCount) + " ，总库存价值：" + _vm._s(_vm.totalInfoForBar.totalMoney))]) : _c('span', [_vm._v("总库存剩余数：" + _vm._s(_vm.totalInfo.totalCount) + " ，总库存价值：" + _vm._s(_vm.totalInfo.totalMoney))])]), _vm._v(" "), _c('div', {
    staticClass: "out-excel"
  }, [_c('span', {
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出excel")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改到期时间",
      "visible": _vm.showModify,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModify = $event
      }
    }
  }, [_c('div', {
    staticClass: "end-time"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("请设置到期时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "default-time": "12:00:00"
    },
    model: {
      value: (_vm.endTimeForThisItem),
      callback: function($$v) {
        _vm.endTimeForThisItem = $$v
      },
      expression: "endTimeForThisItem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modify-btn"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showModify = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "sure",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.modifyThisItem.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec",
      "border-right": "2px solid #ddd"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("出库")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("上月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("采购入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("调拨入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "border-right": "2px solid #ddd"
    }
  }, [_vm._v("吧台退回")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("出货至吧台")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("退货出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("调拨出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("本月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("剩余价值")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec",
      "border-right": "2px solid #ddd"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("出库")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("上月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("吧台上架")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("仓库至吧台")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "border-right": "2px solid #ddd"
    }
  }, [_vm._v("退单入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("销售出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("吧台下架")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("吧台退回仓库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("本月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("剩余价值")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-17fdf6a4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/saleInfo/stockData/stockData.vue
// module id = 926
// module chunks = 1